import React, { PureComponent } from 'react'
const { getComponent } = require('@supersoccer/gandalf')
const LazyloadComponent = getComponent('lazyload')

/**
 *
 * @param {string} alt Image title for improving SEO
 * @param {string} containerClassName Image wrapper external class attributes
 * @param {object} containerStyle Image wrapper external styles CSS properties
 * @param {string} className Img tag class attributes
 * @param {string} style Img tag styles CSS properties
 * @param {function} onClick typical javascript onClick function
 * @param {React.Node} children react component
 * @param {string} src image url e.g. https://mola.tv/mola.png
 * @param {string} errorImgClassName custom error for fallback image, incase of failed to load (e.g. class that has own custom background / custom background-image url)
 * @param {string} fallbackImageUri Default image to be displayed before real image is being loaded (recommended size < 50kb)
 *
 */
// only pass src OR children, cannot both
class Lazyload extends PureComponent {
  render() {
    return <LazyloadComponent {...this.props} />
  }
}

export default Lazyload
